import React, { useState } from "react";
import { TextField, InputAdornment } from "@mui/material";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import SearchIcon from "@mui/icons-material/Search";

const SearchBar = ({ onSearch, searchIcon }: any) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleTextChange = (event: any) => {
    setSearchTerm(event.target.value);
    onSearch(event.target.value);
  };

  return (
    <TextField
      variant="outlined"
      placeholder="Search name..."
      size="small"
      value={searchTerm}
      onChange={handleTextChange}
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            {searchIcon === "user" || searchIcon === "Admin" ? (
              <PersonSearchIcon sx={{ color: "text.secondary" }} />
            ) : (
              <SearchIcon sx={{ color: "text.secondary" }} />
            )}
          </InputAdornment>
        ),
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "20px",
          backgroundColor: "background.paper",
        },
      }}
    />
  );
};

export default SearchBar;

